import request from "@/CommonDP/utils/request";
export default {
  //查询内部成员树
  queryInteriorTree(prjId) {
    return request.get(`/insiders/role/tree?prjId=${prjId}`).then(res => res);
  },

  //查询外部成员树
  queryExternalTree(prjId) {
    return request.get(`/outsiders/role/tree?prjId=${prjId}`).then(res => res);
  },

  //查询内部角色下的成员列表
  queryInteriorPersonList(prjId,roleId) {
    return request.get(`/insiders/role/staff/list?prjId=${prjId}&roleId=${roleId}`).then(res => res);
  },

  //查询外部角色下的成员列表
  queryExternalPersonList(prjId,roleId) {
    return request.get(`/outsiders/role/staff/list?prjId=${prjId}&roleId=${roleId}`).then(res => res);
  },

  //添加内部人员
  addInteriorPerson(data) {
    return request.post(`/insiders/add`,data).then(res => res);
  },

  //添加外部人员
  addExternalPerson(data) {
    return request.post(`/outsiders/add`,data).then(res => res);
  },

  //删除内部人员
  delInteriorPerson(data) {
    return request.post(`/insiders/role/staff/delete`,data).then(res => res);
  },

  //删除外部人员
  delExternalPerson(data) {
    return request.post(`/outsiders/role/staff/delete`,data).then(res => res);
  },


  //查询添加外部人员角色树
  queryExternalRoleTree (enterpriseId, prjId) {
    return request
    .get(`/supplier-org/manage/org-user-list?enterpriseId=${enterpriseId}&prjId=${prjId}`)
    .then(res => res);
  },

  //查询添加内部人员角色树
  queryInteriorRoleTree (enterpriseId) {
    return request
    .post(`/org-manage/tree/user?enterpriseId=${enterpriseId}`)
    .then(res => res);
  },

  //查询外部人员详情
  queryExternalPersonDetail (roleStaffId) {
    return request
    .get(`/outsiders/role/staff/detail?roleStaffId=${roleStaffId}`)
    .then(res => res);
  },

  //查询内部人员详情
  queryInteriorPersonDetail (roleStaffId) {
    return request
    .get(`/insiders/role/staff/detail?roleStaffId=${roleStaffId}`)
    .then(res => res);
  }
}
